import { useStore } from 'effector-react'

import {
  $totalCountOfPermissions,
  getPermissions,
  $permissions,
  permissionListMounted,
} from './model'
import { PermissionsRequest } from './types'

export const usePermissionList = () => {
  const permissions = useStore($permissions)
  const loading = useStore(getPermissions.pending)
  const totalCountOfPermissions = useStore($totalCountOfPermissions)

  const onChangePermissionList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: PermissionsRequest) => {
    permissionListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }

  return {
    permissions,
    totalCountOfPermissions,
    loading,
    onChangePermissionList,
  }
}
